import type { VisitQr } from '@gymboard/types'
import QrDisplay from '../qr/QrDisplay'

/**
 * The gym-floor check-in code, small, for a room TV between classes: the
 * entrance screen is the main check-in point, this just saves a walk.
 */
export default function FloorCheckInMini({ qr }: { qr: VisitQr }) {
  return (
    <div className="flex items-center gap-8 bg-[#191C33]/80 border border-[#31365A] rounded-3xl p-6">
      <QrDisplay token={qr.token} signature={qr.signature} expiresAt={qr.expiresAt} size={132} />
      <div className="min-w-0">
        <div className="text-orange-300/80 text-sm font-semibold tracking-[0.2em] uppercase mb-2">
          Gym floor
        </div>
        <p className="text-white text-2xl font-black leading-tight">Training on your own?</p>
        <p className="text-white/50 text-lg mt-1">Scan with the Agaru app to check in.</p>
        {qr.checkInsToday > 0 && (
          <p className="text-white/40 text-base mt-3 tabular-nums">
            {qr.checkInsToday} {qr.checkInsToday === 1 ? 'member has' : 'members have'} checked in today
          </p>
        )}
      </div>
    </div>
  )
}
